import i18n from 'i18next';
import { logger } from 'packages';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import svAll from './locales/sv/all.json';
import enAll from './locales/en/all.json';

let i18nInitialized;

/**
 * Initialize function for i18next
 * Must be run before doing any translations
 * @returns {Promise<Function>} - a promise to the i18next t function
 */
const init = () => {
    i18nInitialized = i18n
        .use(initReactI18next)
        .use(LanguageDetector)
        .init(
            {
                detection: {
                    order: ['htmlTag'],
                    htmlTag: document.html
                },
                defaultNS: ['all'],
                ns: [],
                fallbackLng: 'sv',
                resources: {
                    sv: {
                        all: svAll
                    },
                    en: {
                        all: enAll
                    }
                },
                debug: false,
                interpolation: {
                    escapeValue: false
                },
                react: {
                    useSuspense: false // loading from file currently breaks if this is true
                },
                ...missingKeyLoggingConfig
            },
            err => {
                if (err) {
                    logger('error when loading translations', err);
                }
            }
        );

    return i18nInitialized;
};

const missingKeyLoggingConfig = {
    saveMissing: true,
    missingKeyHandler: (language, namespace, key) =>
        logger(
            `TranslationMissing (javascript) - Unable to find key ${key} (namespace ${namespace}) in language ${language}!`
        ),
    missingInterpolationHandler: (text, value) => {
        logger(
            `InterpolationFailure (javascript) - Unable to interpolate the text "${text}" fully. The following placeholder values were missing: ${JSON.stringify(
                value
            )}`
        );
        return undefined;
    }
};

/**
 * This function helps you make sure that i18next init has completed before continuing
 * @returns {Promise<Function>} - a promise to the i18next t function
 */
export const whenInitialized = () => {
    if (!i18nInitialized) {
        throw new Error(
            "Can't call boot-languages whenInitialized before init!"
        );
    }
    return i18nInitialized;
};

export default init;
